import { Box, Select } from '@chakra-ui/react';

import { LoadingSpinner } from '@/components/ui/spinner';
import { ROLE_ENUM } from '@/const/role';
import { useGetTenants } from '@/features/tenant/api/get-tenant-list';
import { useTenant } from '@/hooks/use-tenant';
import { useUser } from '@/lib/auth';
import { Tenant } from '@/types/tenant';

export const TenantSelect = () => {
  console.info('tenant-select.tsx_1');
  const user = useUser();
  const { tenantId, setTenantId } = useTenant();
  const getTenantListQuery = useGetTenants({});

  // テナント一覧取得
  const tenantList =
    user.data?.role_id == ROLE_ENUM.ADMIN
      ? getTenantListQuery.data?.tenants
      : [];

  if (getTenantListQuery.isLoading) {
    console.info('tenant-select.tsx_2');
    return <LoadingSpinner />;
  }
  console.info('tenant-select.tsx_3');

  // テナント変更
  const changeTenant = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.info('tenant-select.tsx_4');
    const selectedTenantId = parseInt(e.target.value) || undefined;
    if (setTenantId && user.data?.role_id == ROLE_ENUM.ADMIN) {
      console.info('tenant-select.tsx_5');
      setTenantId(selectedTenantId);
    }
    console.info('tenant-select.tsx_6');
  };

  return (
    <Box ml={4}>
      <Select
        placeholder="テナントを選択"
        bg="white"
        color="black"
        onChange={changeTenant}
        value={tenantId ?? undefined}
      >
        {(tenantList as Tenant[]).map((tenant: Tenant) => (
          <option key={tenant.url_slug} value={tenant.id}>
            {tenant.tenant_name}
          </option>
        ))}
      </Select>
    </Box>
  );
};
